import React from 'react';
import { CLOUDFRONT_ASSET_URL } from '@osmosis/constants';
import Head from 'next/head';

type OpenGraphMetaDataProps = {
  type?: string;
  title?: string;
  descr?: string;
  image?: string;
  url?: string;
  imageWidth?: string;
  video?: string;
  videoUrl?: string;
  videoSecureUrl?: string;
  videoType?: string;
  audio?: string;
};

/**
 * Head component for OpenGraph metadata.
 */
const OpenGraphMetaData = (props: OpenGraphMetaDataProps): JSX.Element => {
  const {
    type = 'website',
    title = 'Osmosis - A Better Way To Learn',
    descr = "Osmosis is an efficient, enjoyable, and social way to learn. Sign up for an account today! Don't study it, Osmose it.",
    image = `${CLOUDFRONT_ASSET_URL}3800be6d2ddada94d64b161e67f637d496dd732e.png`,
    url = 'https://www.osmosis.org/',
    imageWidth,
    video,
    videoUrl,
    videoSecureUrl,
    videoType,
    audio,
  } = props;

  return (
    <Head>
      <meta property="og:site_name" content="Osmosis" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={descr} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      {imageWidth ? (
        <meta property="og:image:width" content={imageWidth} />
      ) : null}
      {video && video !== 'none' ? (
        <meta property="og:video" content={video} />
      ) : null}
      {videoUrl && videoUrl !== 'none' ? (
        <meta property="og:video:url" content={videoUrl} />
      ) : null}
      {videoSecureUrl && videoSecureUrl !== 'none' ? (
        <meta property="og:video:secure_url" content={videoSecureUrl} />
      ) : null}
      {videoType ? <meta property="og:video:type" content={videoType} /> : null}
      {audio ? <meta property="og:audio" content={audio} /> : null}
    </Head>
  );
};

export default OpenGraphMetaData;
